import React from "react"
import { compose, withHooks } from "enhancers"
import { Avatar } from "components"
import { AvatarProps } from "@material-ui/core"

const ImageUploadWithoutForm = (props: AvatarProps) => (
  <Avatar {...props} variant="square" style={{ height: 120, width: 120 }} src={props.src} />
)

const enhancer = compose(
  withHooks((props: any, hooks: any) => {
    const { useEffect, useState } = hooks
    const { value, ...rest } = props

    const [image, setImage] = useState(value)

    const file = image
    const { url, filename } = file
    useEffect(() => {
      if (filename && url) {
        const loadFile = async () => {
          const blob = await fetch(url).then((r) => r.blob())
          const file = new File([blob], filename, { type: blob.type })
          // form.setFieldValue(field.name, file);
          setImage(file)
        }
        loadFile()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [url, filename])

    const src = file instanceof File ? URL.createObjectURL(file) : null

    return {
      ...rest,
      src,
    }
  }),
)

export default enhancer(ImageUploadWithoutForm)
